/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, date: NonNullable<unknown> }} User_Sponsored_ByInputs */



/**
* | output |
* | --- |
* | "Sponsored by {name} on {date}" |
*
* @param {User_Sponsored_ByInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_sponsored_by = /** @type {((inputs: User_Sponsored_ByInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Sponsored_ByInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Parrainé par ${i?.name} le ${i?.date}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Avalado por ${i?.name} el ${i?.date}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Apadrinhado por ${i?.name} em ${i?.date}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Sponsorizzato da ${i?.name} il ${i?.date}`)
	return /** @type {LocalizedString} */ (`Sponsored by ${i?.name} on ${i?.date}`)
});